
import service from '@/utils/request';

// 查询供应商列表  0未审核，1合格供应商，2潜在供应商，3不合格供应商
export function supplierInfoList(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierInfo/supplierInfoList',
        data: param
    })
}

// 查询供应商分类 分页
export function supplierClassificationList(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierClassification/supplierClassificationList',
        data: param
    })
}

// 查询供应商分类 不分页
export function supplierClassificationListAll(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierClassification/list',
        data: param
    })
}


// 根据父Id或取子分类
export function queryByParentId(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierClassification/queryByParentId',
        data: param
    })
}

// 编辑分类
export function classEdit(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierClassification/edit',
        data: param
    })
}

// 修改供应商等级
export function updategysdj(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierInfo/updategysdj',
        data: param
    })
}
// 新增分类
export function classAdd(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierClassification/add',
        data: param
    })
}

// 删除供应商分类
export function delSupplierClassification(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierClassification/del',
        data: param
    })
}

// 审核供应商
export function auditBasicInfo(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierApprovalRecord/passOrReject',
        data: param
    })
}
export function getSupplierApprovalRecordList(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierApprovalRecord/supplierApprovalRecordList',
        data: param
    })
}
// export function supplierApprovalRecordList(param) {
//     return service.request({
//         method: 'POST',
//         url: '/app/supplierApprovalRecord/supplierApprovalRecordList',
//         data: param
//     })
// }



